/* STOPI pages: cart quantity auto-update */
(function () {
  if (window.__stopiPages) { return; }
  window.__stopiPages = true;
  function init() {
    var form = document.querySelector('[data-cart]');
    if (!form || form.__stopiCart) { return; }
    form.__stopiCart = true;
    var t;
    function submitUpdate() {
      clearTimeout(t);
      t = setTimeout(function () {
        var h = document.createElement('input'); h.type = 'hidden'; h.name = 'update'; h.value = '1'; form.appendChild(h); form.submit();
      }, 450);
    }
    [].forEach.call(form.querySelectorAll('[data-q]'), function (b) {
      b.addEventListener('click', function () {
        var input = b.parentNode.querySelector('[data-qty]');
        input.value = Math.max(0, (+input.value || 0) + (+b.dataset.q));
        submitUpdate();
      });
    });
    [].forEach.call(form.querySelectorAll('[data-qty]'), function (i) { i.addEventListener('change', submitUpdate); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
